import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AssesmentComponent } from './shared/components/assesment/assesment.component';
import { AuthGuard } from './helpers/auth.guard';
import { VerifiedCvComponent } from './features/cv/components/verified-cv/verified-cv.component';

const routes: Routes = [
  {
    path: '',
    component: BasicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) }
    ]
  },
  {
    path: 'auth',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'assesment', component: AssesmentComponent },
      { path: 'assesment/:id', component: AssesmentComponent },
      { path: 'profile', loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule) },
      { path: 'applicants', loadChildren: () => import('./features/applicants/applicants.module').then(m => m.ApplicantsModule) },
      { path: 'cv', loadChildren: () => import('./features/cv/cv.module').then(m => m.CvModule) },
      { path: 'home', loadChildren: () => import('./features/homepage/homepage.module').then(m => m.HomepageModule) },
      // { path: 'applicants/:id', loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule) },
      { path: 'jobs', loadChildren: () => import('./features/jobs/jobs.module').then(m => m.JobsModule) },
      { path: 'myjobs', loadChildren: () => import('./features/jobs/jobs.module').then(m => m.JobsModule) },
    ]
  },
  { path: 'verified-cv/:id', component: VerifiedCvComponent },
  { path: 'verified-cv/:id/:type', component: VerifiedCvComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
